import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import Capable from "../../../common/mixins/capable";
import Shareable from "../../../common/mixins/shareable";
import {RelationType} from "../../../common/models/relationType";
import Share from "../../../common/models/share";
import Folder from "./folder";
import Folderable from "./mixins/folderable";
import Organization from "~/models/organization";
import store from "../../../common/state/store";

export default class Application extends Capable(Folderable) {
  name: string;
  organization_id: string;
  groups: any[] = []
  app_deployment_configs: any[] = []

  static get displayName(): string {
    return 'Application';
  }

  get organization() {
    return Organization.repo.find(this.organization_id);
  }

  set organization(organization) {
    this.organization_id = organization.id;
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'folders': { type: Folder, relationType: RelationType.array },
    };
  }

  moveDocument(doc, newParent): void {
    const oldParent = doc.parent;
    // don't move if trying to move to:
    // current location
    if (oldParent !== newParent) {
      store.dispatch('organizationStore/moveDocument', {organization: doc.organization, document: doc, newParent: newParent});
      oldParent.removeDocument(doc);
      newParent.addDocument(doc);
    }
  }

  get archiveFolder() {
    return this.folders.find(f => f.name === 'Archive');
  }

  get rootFolder() {
    return this.folders.find(f => !f.isArchiveFolder())
  }

}